import { Component } from "react";
import { getPopularMoods } from "../shuffle-moods";
import { recordMoodUsed } from "../slowed-memory";
import ChipRow from "./chip-row";

export default class Mood extends Component {
  componentDidMount() {
    // The sheet now mounts already open, so there is no false→true update.
    if (this.props.open && !this.props.isProFeaturesLocked) {
      this.props.onOpen?.({ source: "section" });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      if (!this.props.isProFeaturesLocked) {
        this.props.onOpen?.({ source: "section" });
      }
    }
  }

  setOpen(open) {
    this.props.onOpenChange?.(open);
  }

  async pickMood(mood) {
    if (this.props.isProFeaturesLocked) {
      this.props.onLockedClick?.({ source: "mood", mood: mood?.name });
      this.props.onUpgradeClick?.();
      return;
    }

    if (this.props.selectedMoodName === mood.name) {
      this.setOpen(false);
      try {
        await this.props.onClearMood?.();
      } catch {
        // Sheet is already closing; ignore apply errors.
      }
      return;
    }

    this.setOpen(false);
    try {
      await this.props.onApplyMood?.(mood);
      await recordMoodUsed(mood.name);
    } catch {
      // Sheet is already closing; ignore apply errors.
    }
  }

  render() {
    const { open, isProFeaturesLocked, selectedMoodName } = this.props;
    const moods = getPopularMoods();
    const locked = !!isProFeaturesLocked;

    return (
      <div
        id="mood-sheet"
        className={`mood${open ? " mood--open" : ""}${
          locked ? " mood--locked" : ""
        }`}
        aria-label="Moods"
        aria-hidden={!open}
        {...(!open ? { inert: true } : {})}
      >
        <div className="mood__header">
          <div className="content__title">Moods</div>
          <p className="mood__subtitle">Pick a slowed mood.</p>
        </div>

        <ChipRow>
          {moods.map((mood) => {
            const isSelected = selectedMoodName === mood.name;
            return (
              <button
                key={mood.name}
                type="button"
                className={`mood__chip${isSelected ? " mood__chip--selected" : ""}${locked ? " mood__chip--locked" : ""}`}
                onClick={() => this.pickMood(mood)}
                aria-disabled={locked || undefined}
                title={mood.name}
                aria-pressed={isSelected}
                tabIndex={open ? 0 : -1}
              >
                <span className="mood__chip-name">{mood.name}</span>
              </button>
            );
          })}
        </ChipRow>
      </div>
    );
  }
}
